import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback } from 'react';
import useDisplayShareToast from '@/vdp/Actions/ShareToastContent/useDisplayShareToast';
import { shareData as defaultShareData } from '~/constants/vdp/shareData';
import { useIsMobile, useIsNative } from '~/context/common/DeviceContext';
import { sendMessageToNative } from '~/native/vdp/dispatchers';
import { generateErrorLogger } from '~/utilities/loggers';

export type ShareData = {
  title?: string;
  text?: string;
};

function shareOrCopyUrl(isMobile: boolean, shareData: ShareData = {}) {
  const url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set('utm_source', 'vdp-social-share');

  if (isMobile && navigator.share && navigator.canShare(shareData)) {
    return navigator.share({ url: url.href, ...shareData });
  }

  return navigator.clipboard.writeText(url.href);
}

export default function useShareLink(shareData: ShareData = defaultShareData) {
  const isNative = useIsNative();
  const isMobile = useIsMobile();
  const displayShareToast = useDisplayShareToast();

  return useCallback(() => {
    if (isNative) {
      sendMessageToNative(DispatcherEvent.Share, {});
    } else {
      shareOrCopyUrl(isMobile, shareData)
        .then(() => {
          return displayShareToast();
        })
        .catch(generateErrorLogger('Share link', { shareData }));
    }
  }, [displayShareToast, isMobile, isNative, shareData]);
}
